import { Dropdown, Icon } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import secondsToDuration from "astrid-firestore/src/api/articles/utils/secondsToDuration";

import ArtifactFilesUploadForm from "../../../../artifacts/components/ArtifactFilesUpload/ArtifactFilesUploadForm";
import ArtfactIcon from "../../../../artifacts/components/ArtifactIcon/ArtifactIcon";
import useArtifactContentType from "../../../../artifacts/hooks/useArtifactContentType";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import Label from "../../../../ui/components/Label/Label";

export default function ArticleArtifact({ work, article, selectedArtifact, archivedArtifacts, publisher }) {
	const { t } = useTranslation();

	const [uploadOpen, setUploadOpen] = useState(false);

	const { icon, text } = useArtifactContentType({ artifact: selectedArtifact });

	const hasArtifacts = selectedArtifact || archivedArtifacts.length > 0;

	const triggerLabel = (
		<Label basic style={{ cursor: "pointer" }}>
			<Icon name={selectedArtifact ? icon : "upload"} color={selectedArtifact && "green"} />

			{selectedArtifact
				? `${text}${
						selectedArtifact.duration
							? ` - ${secondsToDuration(selectedArtifact.duration, { padHours: 2 })}`
							: ""
				  }`
				: t("uploadFiles", "Upload files")}
		</Label>
	);

	return (
		<>
			{hasArtifacts ? (
				<DropdownMenu
					trigger={triggerLabel}
					options={[
						{
							text: t("uploadNewArtifact", "Upload new artifact"),
							icon: "upload",
							action: () => setUploadOpen(true),
						},
					]}
				>
					{selectedArtifact && (
						<>
							<ArtifactDropdownItem artifact={selectedArtifact} article={article} selected />

							<Dropdown.Divider />
						</>
					)}

					{archivedArtifacts.length > 0 && (
						<>
							{archivedArtifacts.map((a) => (
								<ArtifactDropdownItem key={a.id} artifact={a} article={article} selected={false} />
							))}

							<Dropdown.Divider />
						</>
					)}
				</DropdownMenu>
			) : (
				<span onClick={() => setUploadOpen(true)}>{triggerLabel}</span>
			)}

			{uploadOpen && (
				<ArtifactFilesUploadForm
					work={work}
					article={article}
					publisher={publisher}
					defaultName={article.name}
					onClose={() => setUploadOpen(false)}
				/>
			)}
		</>
	);
}

function ArtifactDropdownItem({ artifact, article, selected }) {
	const { text } = useArtifactContentType({ artifact });

	return (
		<Dropdown.Item as={Link} to={`articles/${article.id}/artifacts/${artifact.id}`}>
			<div style={{ display: "flex", alignItems: "center", gap: "0.8em" }}>
				<ArtfactIcon artifact={artifact} selected={selected} size={16} />

				<div>
					<div>{artifact.name}</div>

					<div style={{ opacity: 0.5, fontSize: "0.85em" }}>
						{text}

						{!!artifact.duration && ` - ${secondsToDuration(artifact.duration, { padHours: 2 })}`}

						{" · "}

						{artifact.created?.toDate()?.toLocaleDateString()}
					</div>
				</div>
			</div>
		</Dropdown.Item>
	);
}
